import React from "react";
import Meta from "../components/meta";

const Four0Four = () => {
  return (
    <div id="four0Four">
      <Meta fourOFour={true} noIndex={true} />
      <div className="content">
        <h1>404</h1>
      </div>
    </div>
  );
};

export default Four0Four;
